import { Grid } from "@material-ui/core";
import MainCard from "../../../components/common/MainCard";
import ScreenTitle from "../../../components/common/ScreenTitle";
// import AddClientForm from "../forms/AddClientForm";

const AddClientScreen = () => {
  return (
    <Grid container spacing={2}>
      <ScreenTitle title="Crear Nueva Empresa" backButton />
      <MainCard>{/* <AddClientForm /> */}</MainCard>
    </Grid>
  );
};

export default AddClientScreen;
